import type React from "react"

export const Layout_1_2: React.FC<React.SVGAttributes<SVGSVGElement>> = (
  props,
) => (
  <svg
    width="22"
    height="27"
    viewBox="0 0 22 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Layout 1-2</title>
    <path
      d="M3.74026 4.74026C3.74026 4.18798 4.18797 3.74026 4.74026 3.74026H16.4503C17.0025 3.74026 17.4503 4.18797 17.4503 4.74026V10.8442C17.4503 11.3964 17.0025 11.8442 16.4503 11.8442H4.74026C4.18798 11.8442 3.74026 11.3964 3.74026 10.8442V4.74026Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M3.74023 15.026C3.74023 14.4737 4.18795 14.026 4.74023 14.026H8.974C9.52629 14.026 9.974 14.4737 9.974 15.026V21.1299C9.974 21.6821 9.52629 22.1299 8.974 22.1299H4.74023C4.18795 22.1299 3.74023 21.6821 3.74023 21.1299V15.026Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M11.2207 15.026C11.2207 14.4737 11.6684 14.026 12.2207 14.026H16.4545C17.0068 14.026 17.4545 14.4737 17.4545 15.026V21.1299C17.4545 21.6821 17.0068 22.1299 16.4545 22.1299H12.2207C11.6684 22.1299 11.2207 21.6821 11.2207 21.1299V15.026Z"
      fill={props.fill ?? "#2C1789"}
    />
    <path
      d="M17.6623 0H3.53247C1.54545 0 0 1.48295 0 3.27273V22.9091C0 24.75 1.54545 26.1818 3.53247 26.1818H17.6623C19.5942 26.1818 21.1948 24.75 21.1948 22.9091V3.27273C21.1948 1.48295 19.5942 0 17.6623 0ZM19.4286 22.9091C19.4286 23.8295 18.6007 24.5455 17.6623 24.5455H3.53247C2.53896 24.5455 1.76623 23.8295 1.76623 22.9091V3.27273C1.76623 2.40341 2.53896 1.63636 3.53247 1.63636H17.6623C18.6007 1.63636 19.4286 2.40341 19.4286 3.27273V22.9091Z"
      fill={props.fill ?? "#2C1789"}
    />
  </svg>
)
